(() => {
  if (window.__wimTextColumnsBound) return;
  window.__wimTextColumnsBound = true;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const PUB_SUB = (window.theme && window.theme.PUB_SUB_EVENTS) || {};
  const CART_UPDATE = PUB_SUB.cartUpdate;
  const CART_ERROR = PUB_SUB.cartError;
  const COOLDOWN_MS = 400;

  const addToCart = async (variantId) => {
    const res = await fetch(`${ROOT}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
    const data = await res.json();
    if (!res.ok) throw data;
    return data;
  };

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-wim-atc]');
    if (!btn) return;

    const variantId = btn.getAttribute('data-wim-atc');
    if (!variantId) return;

    event.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    try {
      const result = await addToCart(variantId);

      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', { bubbles: true }));

      if (typeof window.publish === 'function' && CART_UPDATE) {
        window.publish(CART_UPDATE, {
          source: 'wim-text-columns',
          productVariantId: variantId,
          cartData: result,
        });
      }
    } catch (error) {
      console.error('[wim-text-columns] cart/add failed', error);
      if (typeof window.publish === 'function' && CART_ERROR) {
        window.publish(CART_ERROR, {
          source: 'wim-text-columns',
          productVariantId: variantId,
          errors: (error && (error.description || error.message)) || 'cart_add_failed',
        });
      }
    } finally {
      btn.removeAttribute('aria-busy');
      setTimeout(() => {
        btn.disabled = false;
      }, COOLDOWN_MS);
    }
  });
})();
